import React, { useState } from 'react';
import api from '../../services/seguridadProvider';

import { Button, Form, message, Input, Switch } from 'antd';
import { LoginOutlined } from '@ant-design/icons/lib';

import PublicLayout from '../../layout/public/Public';
import { Link } from 'react-router-dom';
import { useForm } from 'antd/es/form/Form';
import { navigateHome } from '../../utils/naviagate-home';

const { Item } = Form;

const SignIn = () => {
  const [cargando, setCargando] = useState(false);
  const [form] = useForm();

  const login = async () => {
    try {
      const val = await form.validateFields();
      setCargando(true);

      const response = await api.login(val.usr, val.psw).catch((err) => {
        setCargando(false);
        form.resetFields();
        if (err.response.status === 500) {
          message.error(err.response.data);
          return;
        }
        if (err.response.status === 512) {
          message.error('FUERA DE LINEA');
          return;
        }
        if (err.response.status === 401) {
          message.info('Usuario o Clave incorrecta.');
          return;
        }
      });
      if (response) {
        setCargando(!response);
        form.resetFields();
        navigateHome();
      }
      console.log('Success:', val);
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
    }
  };

  return (
    <PublicLayout transparent={true} bgImg={`${window.origin}/content/gessoma.png`}>
      <h4 className='mt-0 mb-1'>Ingreso</h4>
      <p className='text-color-200'>Login para acceder a su cuenta de usuario.</p>
      <Form form={form} layout='vertical' className='mb-4'>
        <Item name='usr' rules={[{ required: true, message: 'Ingrese usuario' }]}>
          <Input placeholder='Usuario' />
        </Item>
        <Item name='psw' rules={[{ required: true, message: 'Ingrese clave.' }]}>
          <Input.Password placeholder='Contraseña' type='password' />
        </Item>

        <div className='d-flex align-items-center mb-4'>
          <Switch defaultChecked /> <span className='ml-2'>Recordarme</span>
        </div>

        <Button
          block={false}
          type='primary'
          className={''}
          loading={cargando}
          onClick={login}
          htmlType='submit'
          icon={<LoginOutlined style={{ fontSize: '1.3rem' }} />}
        >
          Ingresar
        </Button>
      </Form>
      {/*<br />*/}
      {/*<p className='mb-1'>*/}
      {/*  <a href='#'>Olvido su contraseña?</a>*/}
      {/*</p>*/}

      {/*<p>*/}
      {/*  No tiene una cuenta? <Link to='sign-up'>Registrarse!</Link>*/}
      {/*</p>*/}
    </PublicLayout>
  );
};

export default SignIn;
